/**
 * @generated SignedSource<<0cc9377ab06f086fb429df93e0ec36be>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectPartnerWithAction_userProfile$data = {
  readonly analyticsId: number;
  readonly avatarImage: {
    readonly uid: string;
    readonly url: string;
  } | null;
  readonly displayUsername: string;
  readonly firstName: string | null;
  readonly id: string;
  readonly " $fragmentType": "ProjectPartnerWithAction_userProfile";
};
export type ProjectPartnerWithAction_userProfile$key = {
  readonly " $data"?: ProjectPartnerWithAction_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectPartnerWithAction_userProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectPartnerWithAction_userProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "analyticsId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUsername",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContraImage",
      "kind": "LinkedField",
      "name": "avatarImage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uid",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};

(node as any).hash = "1ca8d1c6d6ba336d1b0436882f369ae6";

export default node;
